import { MotifFormField, MotifInput, MotifLabel } from '@ey-xd/motif-react'
import React, { useState, useEffect } from 'react'
import { updateExtraxtedText } from '../AnnotateSlice'
import { useDispatch } from 'react-redux'
interface UserPermissionItemProps {
  recordIndex: number
  evidenceId: string
  annotationTypeId?: string;
  personName: string
  userGroup: string
  list: string
  pageNumber: number // Added 'pageNumber' property
  evidenceAnnotationId?: string
  originalRecord?: any
}
interface UserInfo {
  personName?: string // Added 'name' property
  userGroup?: string // Added 'group' property
  list?: string // Added 'department' property
}
export const OtherDetails = ({
  evidenceId,
  recordIndex,
  annotationTypeId,
  personName,
  userGroup,
  list,
  pageNumber,
  evidenceAnnotationId,
  originalRecord,
}: UserPermissionItemProps) => {
  const changed = (field: string, current: any) =>
    originalRecord != null && (current ?? '') !== (originalRecord[field] ?? '')
  const dispatch = useDispatch()
  const [otherDetails, setOtherDetails] = useState<UserInfo | null>({
    personName: personName? personName : '',
    userGroup: userGroup? userGroup : '',
    list: list? list : '',
  })
  useEffect(() => {
    setOtherDetails({
      personName: personName ? personName : '',
      userGroup: userGroup ? userGroup : '',
      list: list ? list : '',
    })
  }, [personName, userGroup, list])
  useEffect(() => {
    dispatch(
      updateExtraxtedText({
        evidenceId: evidenceId,
        recordIndex: recordIndex,
        annotationTypeId: annotationTypeId,
        extractedText: otherDetails,
        pageNumber: pageNumber ? pageNumber : 1, // Use the provided pageNumber or default to 1
        evidenceAnnotationId: evidenceAnnotationId,
      }),
    )
  }, [otherDetails])
  const handleUserDetailsChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    setOtherDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }))
  }
  return (
    <div className="user-detail-tab">
        <div className={changed('personName', otherDetails?.personName) ? 'field-changed' : ''}>
        <MotifFormField aria-label="Input" role="group">
          <MotifLabel aria-label="name" position="in">
            Name
          </MotifLabel>
          <MotifInput
            id="name"
            label="Name"
            name="name"
            onChange={handleUserDetailsChange}
            aria-label="name"
            labelPosition="in"
            value={otherDetails?.personName}
            hideClearButton
            autoComplete="off"
          />
        </MotifFormField>
        </div>
        <div className={changed('userGroup', otherDetails?.userGroup) ? 'field-changed' : ''}>
        <MotifFormField aria-label="Input" role="group">
          <MotifLabel aria-label="group" position="in">
            Group
          </MotifLabel>
          <MotifInput
            id="group"
            name="userGroup"
            labelPosition="in"
            value={otherDetails?.userGroup}
            onChange={handleUserDetailsChange}
            hideClearButton
            autoComplete="off"
          />
        </MotifFormField>
        </div>
        <div className={changed('list', otherDetails?.list) ? 'field-changed' : ''}>
        <MotifFormField aria-label="Input" role="group">
          <MotifLabel aria-label="list" position="in">
            List
          </MotifLabel>
          <MotifInput
            id="list"
            name="list"
            labelPosition="in"
            value={otherDetails?.list}
            onChange={handleUserDetailsChange}
            hideClearButton
            autoComplete="off"
          />
        </MotifFormField>
        </div>
    </div>
  )
}
